import { atom } from "recoil";

export const mainSelectedTab = atom({
  key: "mainSelectedTab",
  default: 0,
});

export const selectedTab = atom({
  key: "selectedTab",
  default: 0,
});

export const camsTabs = atom({
  key: "camsTabs",
  default: undefined,
});

export const permittedTabs = atom({
  key: "permittedTabs",
  default: undefined,
});

export const paginationData = atom({
  key: "paginationData",
  default: 0,
});
export const pageNumData = atom({
  key: "pageNumData",
  default: 0,
});

export const isPrevPageState = atom({
  key: "isPrevPageState",
  default: false,
});
export const isNewModuleState = atom({
  key: "isNewModuleState",
  default: false,
});

export const urlPath = atom({
  key: "urlPath",
  default: "",
});

export const officeSelectedTab = atom({
  key: "officeSelectedTab",
  default: 0,
});

export const mainTab = atom({
  key: "mainTab",
  default: 0,
});
export const notifTabIndex = atom({
  key: "notifTabIndex",
  default: 0,
});
export const onCloseSetPage = atom({
  key: "onCloseSetPage",
  default: false,
});

export const isReportTabClick = atom({
  key: "isReportTabClick",
  default: false,
});
